<template>
  <div
    v-if="(!useAuthStore().isLoggedIn || !(useAuthStore().user?.is_operator || useAuthStore().isUserOrganization)) && props.youtube"
    :class="{ 'video-help--small': breakpointSmallerMd }"
    class="video-help"
  >
    <el-tooltip
      effect="dark"
      :content="$t('VideoHelp.tooltip')"
    >
      <el-button
        :type="props.type"
        :size="props.size"
        circle
        @click="isOpen = true"
      >
        <span class="sr-only">
          {{ $t('VideoHelp.help') }} - {{ props.title }}
        </span>
        <icon-interpreting />
      </el-button>
    </el-tooltip>

    <el-dialog
      v-model="isOpen"
      :title="`${$t('VideoHelp.tooltip')} - ${props.title}`"
      width="750px"
      top="10vh"
      class="el-dialog--spaceless-body"
      append-to-body
    >
      <template #header>
        <span>
          <icon-interpreting /> {{ $t('VideoHelp.help') }} - {{ props.title }}
        </span>
      </template>
      <div class="video-wrapper">
        <iframe
          :title="props.title"
          width="560"
          height="315"
          :src="`https://app.tichalinka.cz/youtube.html?v=${props.youtube}&autoplay=1`"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        />
        <div class="video-placeholder flex items-center justify-center">
          <icon-loading />
        </div>
      </div>

      <template #footer>
        <div class="text-center w-full">
          <el-button
            size="small"
            @click="isOpen = false"
          >
            {{ $t('close') }}
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  youtube: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: 'default',
  },
  size: {
    type: String,
    default: 'small',
  },
});

// Refs
const isOpen = ref(false);

// Computed
const breakpointSmallerMd = useBreakpoint.smaller('md');
</script>
